/** cookie 名稱與 Spring 的 `CookieCsrfTokenRepository` 預設一致。 */
const CSRF_COOKIE = 'XSRF-TOKEN';

/**
 * 讀取 CSRF token。
 *
 * 這個 cookie 刻意**不是** HttpOnly —— 它不是憑證，只是用來證明請求來自能讀取
 * 本站回應的頁面；真正的憑證是 HttpOnly 的 session cookie。
 *
 * ⚠️ cookie 的 domain 為 `codeincold.com`，故本機開發（localhost）讀不到，
 *    登出與寫入操作在本機都不會成功。見 shared-auth README「本機開發的限制」。
 */
export function readCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;

  const match = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${CSRF_COOKIE}=`));

  return match ? decodeURIComponent(match.slice(CSRF_COOKIE.length + 1)) : null;
}
